// src/app/hooks/coil/queries.ts
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  useGetCoilParamsQuery,
  useGetHandsQuery,
  useLazyGetCoilQuery,
  useLazyGetRatedCoilQuery,
} from '../../services';
import { setCoil, setCoilParams, setConnHands } from '../../slices';

export const useGetCoilMainData = (id: number) => {
  const { isLoading: coilLoading, ratedCoilLoading } = useGetCoil(id);
  const { isLoading } = useGetCoilParams();

  return {
    isLoading: isLoading || coilLoading || ratedCoilLoading,
  };
};

export const useGetCoil = (id: number, fetch = true) => {
  const dispatch = useDispatch();
  const [getCoil, { data: coil, isLoading }] = useLazyGetCoilQuery();
  const [getRatedCoil, { data: ratedCoil, isLoading: ratedCoilLoading }] =
    useLazyGetRatedCoilQuery();

  useEffect(() => {
    if (fetch && id) {
      getCoil(id);
      getRatedCoil(id);
    }
  }, [id]);

  useEffect(() => {
    if (coil) dispatch(setCoil({ ...coil, ...ratedCoil }));
  }, [coil, ratedCoil]);

  return {
    coil,
    ratedCoil,
    isLoading,
    ratedCoilLoading,
    getCoil,
    getRatedCoil,
  };
};

export const useGetCoilParams = () => {
  const dispatch = useDispatch();

  const { data: params, isLoading, refetch } = useGetCoilParamsQuery();

  useEffect(() => {
    if (params) {
      dispatch(setCoilParams(params.coil));
    }
  }, [params]);

  return { isLoading, params, get: refetch };
};

export const useGetConnHands = () => {
  const dispatch = useDispatch();

  const { data, isLoading, refetch } = useGetHandsQuery();

  useEffect(() => {
    if (data) {
      dispatch(setConnHands(data));
    }
  }, [data]);

  return { isLoading, hands: data, get: refetch };
};
